import React, { useContext, useEffect } from "react";
import * as $ from "jquery";
import { AnimatePresence, motion } from "framer-motion";
import useMediaQuery from "@mui/material/useMediaQuery";

import { FilterContext } from "./filters-context";
import fetchGuides from "./fetch-guides";
import ResetFilters from "./filters/reset-filters";
import ThemeFilter from "./filters/theme-filter";
import SyndicatFilter from "./filters/syndicat-filter";
import FiltersVisibility from "./filters-visibility";

const Filters = () => {
  const { filters, toggleFilters } = useContext(FilterContext);
  const isMobile = useMediaQuery("(max-width:767px)");
  useEffect(() => {
    const effectGuides = async () => {
      let $guidesContainer = $(".guides-container");
      const innerHeight = $guidesContainer.innerHeight();
      $guidesContainer.find(".inclusion-card").fadeOut(500, function () {
        $guidesContainer
          .css("height", `${innerHeight}px`)
          .html("")
          .addClass("is-loading");
      });
      const guides = await fetchGuides(filters);
      $guidesContainer
        .html(guides)
        .css("height", "auto")
        .removeClass("is-loading");
      emergence.engage();
    };
    if (filters.isInit) {
      effectGuides();
    }
  }, [filters.theme, filters.syndicat]);
  useEffect(() => {
    toggleFilters(!isMobile);
  }, [isMobile]);
  const variants = {
    open: {
      height: "auto",
      transitionEnd: { overflow: "visible" },
    },
    closed: {
      height: 0,
      overflow: "hidden",
      transition: { overflow: { delay: 0, duration: 0 } },
    },
  };
  return (
    <>
      <AnimatePresence initial={true}>
        {filters.visibility && (
          <motion.div
            initial="closed"
            exit="closed"
            className="inclusion-filters-anim"
            animate={filters.visibility ? "open" : "closed"}
            variants={variants}
            transition={{ duration: 0.4, ease: [0.04, 0.62, 0.23, 0.98] }}
          >
            <div className={`inclusion-filters-container`}>
              <ResetFilters />
              <ThemeFilter />
              <SyndicatFilter />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      <FiltersVisibility />
    </>
  );
};
export default Filters;
